import React from 'react';
import { Modal, Button, Checkbox, Form, Radio, Statistic, Table, DatePicker } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import moment from 'moment';
import dayjs from 'dayjs';
import { EditableRow, EditableCell } from './EditableTable';
import { tableCSS } from './utils';

const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
const bangkokTimezone = "Asia/Bangkok"

const BillModal = ({
    isBillModalOpen,
    handelBillModalCancle,
    billCreate,
    checkSelectedRow,
    isEmployeeUnlock,
    onCheckChange,
    selectedRow,
    columnsBilling,
    form3,
    setIsPayOptionsSelected,
    totalPrice,
    authState
}) => {
    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };

    return (
        <Modal width={1200} title="ออกบิล" open={isBillModalOpen} onCancel={handelBillModalCancle} footer={[<Button key="ok" onClick={billCreate} disabled={checkSelectedRow()}>ตกลง</Button>, <Button key="close" onClick={handelBillModalCancle} >ปิด</Button>]}>

            <Checkbox checked={isEmployeeUnlock} onChange={onCheckChange}>ปลดล็อคพนักงาน[สำหรับพนักงานต่างสาขา]</Checkbox>
            <Table
                components={components}
                rowClassName={() => 'editable-row'}
                columns={columnsBilling} // Use the editable columns for billing
                dataSource={selectedRow}
                bordered
                className={tableCSS}
                size="small"
                scroll={{ x: 'auto' }}
            />
            <Form
                form={form3}
                initialValues={{ date: dayjs().tz(bangkokTimezone) }}
            >
                <Form.Item style={{ marginBottom: "10px" }}
                    label="วิธีการชำระเงิน"
                    name="payment_method"
                    rules={[
                        {
                            required: true,
                            message: 'กรุณาเลือกประเภท',
                        },
                    ]}
                >
                    <Radio.Group onChange={() => { setIsPayOptionsSelected(true) }} >
                        <Radio value="เงินสด" > เงินสด </Radio>
                        <Radio value="โอนธนาคาร" > โอนธนาคาร </Radio>
                        <Radio value="บัตรเครดิต/เดบิต"> บัตรเครดิต/เดบิต </Radio>
                        <Radio value="ไม่มี" > ไม่มี</Radio>
                    </Radio.Group>
                </Form.Item>
                <Form.Item style={{ marginBottom: "10px" }}
                    label="หมายเหตุ"
                    name="remark"
                    rules={[
                        {
                            max: 200,
                            message: 'หมายเหตุต้องไม่เกิน 100 ตัวอักษร',
                        },
                    ]}>
                    <TextArea style={{ width: "20rem" }} maxLength={200}>
                    </TextArea>
                </Form.Item>

                <Form.Item name="date" label="วันที่" rules={[{ required: true, message: 'กรุณาเลือกวันที่' }]} style={{ marginBottom: "10px" }}>
                    <DatePicker
                        disabledDate={(current) => current && current > moment().endOf('day')}
                        disabledTime={(current) => {
                            const now = moment();
                            if (current && current.isSame(now, 'day')) {
                                return {
                                    disabledHours: () => Array.from({ length: 24 }, (_, i) => i).splice(now.hour() + 1),
                                    disabledMinutes: () => Array.from({ length: 60 }, (_, i) => i).splice(now.minute() + 1),
                                    disabledSeconds: () => Array.from({ length: 60 }, (_, i) => i).splice(now.second() + 1),
                                };
                            }
                            return {};
                        }}
                        format="YYYY-MM-DD HH:mm"
                        showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm') }}
                        disabled={authState.role !== 'admin'}
                    />
                </Form.Item>


            </Form>

            <Statistic title="Total Cost (บาท)" value={totalPrice} precision={2} />
        </Modal>
    );
};

export default BillModal;
